import {
  FormControl,
  Icon,
  InputLabel,
  MenuItem,
  Select,
  Theme,
  Typography,
} from "@yuno/design-system-web";
import { useContext } from "react";
import { ThemeContext } from "../../../../../context/theme-context";
import { ToolDescription, ToolsContainer } from "../../styles";
import { useTranslation } from "react-i18next";

const themes = [
  { label: "styles.themeOpt.default", value: "default" },
  { label: "styles.themeOpt.darkMode", value: "darkMode" },
  { label: "styles.themeOpt.minimalist", value: "minimalist" },
  { label: "styles.themeOpt.custom", value: "custom" },
];

const MENU_PROPS = {
  style: {
    marginLeft: "8px",
  },
};

export const ThemeSelector = () => {
  const { themeSelected, setThemeSelected, setUserAction } =
    useContext(ThemeContext);
  const { t } = useTranslation();

  const handleChange = (evt) => {
    evt.stopPropagation();
    setThemeSelected(evt.target.value);
    setUserAction(true);
  };

  return (
    <ToolsContainer>
      <ToolDescription>
        {t('styles.themeDesc')}
      </ToolDescription>
      <FormControl fullWidth>
        <InputLabel id="checkbox-label">{t("styles.theme")}</InputLabel>
        <Select
          labelId="checkbox-label"
          id="checkbox"
          value={themeSelected}
          onChange={handleChange}
          MenuProps={MENU_PROPS}
          IconComponent={(props) => (
            <Icon name="CaretDown" weight="thin" color="#6C6F75" {...props} />
          )}
        >
          {themes.map((option, key) => (
            <MenuItem key={key} value={option.value}>
              {t(option.label)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </ToolsContainer>
  );
};
